import { __awaiter } from "tslib";
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { PixelMessageBuilder } from '@websky/pixel';
import { sendPixelEvent } from '@shared/lib/pixel/sendPixelEvent';
import { useConfig } from '../../context';
const PixelPageViewWatcher = () => {
    const { global: { usePixel } } = useConfig();
    if (!usePixel) {
        return null;
    }
    const location = useLocation();
    const prevLocation = useRef(null);
    const handleLocationChange = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentPath = window.location.href;
        const previousPath = prevLocation.current;
        if (currentPath !== previousPath) {
            yield sendPixelEvent(cdpId => PixelMessageBuilder.buildPageViewEvent(currentPath, previousPath !== null && previousPath !== void 0 ? previousPath : '', cdpId));
            prevLocation.current = currentPath;
        }
    });
    useEffect(() => {
        handleLocationChange();
    }, [location, usePixel]);
    return null;
};
export default PixelPageViewWatcher;
